import { selectProfileId } from '@store/slices/account/accountSlice.js';
import httpClient from '@utils/httpClient.js';
import { call, debounce, select } from 'redux-saga/effects';

import { stickerAdd, stickerRemove, stickerUpdate } from './stickersSlice.js';

// Best-effort autosave: any sticker mutation (add/move/resize/rotate/delete) is
// debounced, then the full sticker array for that page is PUT to the backend.
// Drag fires stickerUpdate on every pointermove, so debouncing is essential.
function* saveStickersSaga(action) {
  try {
    const { pageId } = action.payload || {};
    if (!pageId) return;
    const profileId = yield select(selectProfileId);
    const stickers = yield select((state) => state.stickers.byPage[pageId] || []);
    yield call([httpClient, 'put'], `api/profiles/${profileId}/pages/${pageId}/stickers`, { stickers: JSON.stringify(stickers) });
  } catch {
    // Autosave is non-critical; the next mutation will retry.
  }
}

export function* stickersWatcher() {
  yield debounce(700, [stickerAdd.type, stickerUpdate.type, stickerRemove.type], saveStickersSaga);
}
